import styled from 'styled-components';

import { colors } from '../../../../theme';

export const SuccessCriteriaContainer = styled.div`
  background-color: ${colors.tealishBlue};
  padding-right: 16px;
  font-size: 12px;
`;

export const SuccessCriteriaTitle = styled.div`
  color: ${colors.orangeyYellow80};
  margin-bottom: 8px;
`;

export const SuccessCriteriaItem = styled.div`
  background: ${colors.darkGray};
  border-radius: 12px;
  padding: 8px 16px;
  margin-bottom: 12px;
`;

export const SuccessCriteriaItemTitle = styled.div`
  color: ${colors.white};
  margin-bottom: 4px;
  font-weight: 600;
`;

export const SuccessCriteriaItemText = styled.div`
  color: ${colors.white50};
  margin-bottom: 4px;
  span {
    font-weight: 600;
  }
`;
